export const language = {
    language: 'en'
};
